<div style="height: 100%;">
  <div style="height: 100%;display:flex;">
    <!-- mobile and navbar section ,'width':resizingDoneOnce?newLeftWidth+'px':'auto' [ngStyle]="{'flex':isiPad?'3':'2'}"-->
    <div [ngClass]="isiPad ? 'col-6 col-md-6' : 'col-4 col-md-4'" #mobileAndNavbar id="mobileAndNavbar"
      style="background-color: gray;">
      <div class="parent-col">
        <!-- Mobile device section -->
        <app-device-control [control]="control" [device]="device"></app-device-control>
      </div>
    </div>
    <div class="resizeBar" (mousedown)="resizingStart($event)">
      <div class="resizeBar-handle">
        <div class="resizeBar-grip"></div>
      </div>
    </div>
    <div class="col-8 col-md-8" #DashboardAndLogs id="DashboardAndLogs"
      style="height: -webkit-fill-available; height: -moz-available; height: 100%;">
      <!-- Dashboard and tabs section -->
      <div id="DashboardAndTabs" #dashboard style="height: 100%;">
        <ul class="nav nav-tabs"
          style="max-height:5vh; overflow-x: scroll;overflow-y: hidden ;scrollbar-width: none; ::-webkit-scrollbar {display: none;}">
          <li className="nav-item" style="border-radius: 10px;">
            <span>
              <button id="homeModel" class="btn btn-sm bg-blue-500 rounded flex items-center gap-2"
                (click)="copyToClipboard(device?.model)" title="Click to copy">
                <i class="far fa-copy"
                  style="position:relative;padding:3px;cursor:pointer;font-weight:bolder;color:blue;"></i>
                {{device?.model}}
              </button>
            </span>
          </li>
          <li class="nav-item">
            <a class="nav-link active" data-bs-toggle="tab" data-bs-target="#dashboard"><em
                class="fa fa-dashboard fa-fw" style="color: #ff1fff;"></em>{{"Dashboard" | translate}}</a>
          </li>
          <!-- <li class="nav-item"> -->
          <!-- <a class="nav-link" data-bs-toggle="tab" data-bs-target="#screenshots"><em class="fa fa-camera"
        style="color: #6eb2ff;"></em>{{" Screenshots" | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-bs-toggle="tab" data-bs-target="#Screenrecord"><em class="fa fa-video-camera"
        style="color: #e04415;"></em>{{" Screenrecord" | translate}}</a>
      </li> -->
          <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" data-bs-target="#automation"><em class="fa fa-road"
                style="color: #7369ff;"></em>{{"Automation" | translate}}</a>
          </li>
          <!-- commented for axis -->
          @if(!isIos()){<li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" data-bs-target="#ai-automation"><em class="fa fa-robot"
                style="color: #00bcd4;"></em>{{"AI Automation" | translate}}</a>
          </li>}
          <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" data-bs-target="#media"><em class="fa-solid fa-photo-film"
                style="color: #da1e1e;"></em>{{"Media" | translate}}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" data-bs-target="#logs"><em class="fa fa-chart-gantt"
                style="color: #c04600;"></em>{{"Logs & PT" | translate}}</a>
          </li>
          @if (showFileExplorer) {
          <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" data-bs-target="#files"><em class="fa fa-folder-open"
                style="color: #1f79ff;"></em>{{"File Explorer" | translate}}</a>
          </li>
          }
          <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" data-bs-target="#info"><em class="fa fa-info"
                style="color: #ffb81f;"></em>{{"Info" | translate}}</a>
          </li>
          <!-- <li class="nav-item ms-auto">
      <div class="form-check form-switch border-color" style="position:relative; left: 10px; cursor: pointer;"
        [title]="isLogsVisible ? 'Hide Logs' : 'Show Logs'">
        <input style="position:relative; top: 0.5em; cursor: pointer;" class="form-check-input"
          (change)='toggleLogs()' type="checkbox" id="flexSwitchCheckChecked" checked>
        <label style="position:relative; top: 0.5em; cursor: pointer;" class="form-check-label"
        for="flexSwitchCheckDefault">{{ isLogsVisible ? 'Hide Logs' : 'Show Logs' }}</label>
      </div>
    </li> -->
          <!-- <button class="btn btn border-0 logsbutton" [title]="isLogsVisible ? 'Hide Logs' : 'Show Logs'" aria-label="Toggle Logs" (click)="toggleLogs()">
    <span style="cursor: pointer;">{{ isLogsVisible ? 'Hide' : 'Show' }} Logs</span>
  </button> -->
        </ul>

        <div class="tab-content" style="max-height: 86vh; overflow-y: auto; overflow-x: hidden; scrollbar-width: none;">
          <div id="dashboard" class="tab-pane fade show active">
            @if (renderChildComponent) {
            <app-dashboard [control]="control" [device]="device"></app-dashboard>
            }
          </div>
          <div id="media" class="tab-pane fade">
            @if (renderChildComponent) {
            <app-media [control]="control" [device]="device"></app-media>
            }
          </div>
          <div id="automation" class="tab-pane fade">
            @if (renderChildComponent) {
            <app-automation [device]="device"></app-automation>
            }
            <!-- <app-app-inspector *ngIf="renderChildComponent" [device]="device"></app-app-inspector> -->
          </div>
          <div id="ai-automation" class="tab-pane fade">
            @if (renderChildComponent) {
            <app-ai-automation [device]="device"></app-ai-automation>
            }
          </div>
          <div id="logs" class="tab-pane fade" style="height: 84vh; overflow: hidden;">
            @if (renderChildComponent) {
            <app-logs [device]="device"></app-logs>
            }
          </div>
          <div id="files" class="tab-pane fade">
            @if (renderChildComponent) {
            <app-explorer [control]="control"></app-explorer>
            }
          </div>
          <div id="info" class="tab-pane fade">
            @if (renderChildComponent) {
            <app-info [control]="control" [device]="device"></app-info>
            }
          </div>
          <!-- <div id="app-inspector" *ngIf="isAppInspector" class="tab-pane fade">
  <ng-template>
    <app-app-inspector></app-app-inspector>
  </ng-template>
</div> -->
        </div>

      </div>
      <!-- resize button
<button id="resizer" *ngIf="this.isLogsVisible"
  style="width: 100%; height: 0.5%; background: #ccc; cursor: row-resize; padding: 0;"
(mousedown)="startResizing($event)"></button>
Logs section
<div class="logs" id="Logs" #logs style="height: 40%;">
  <app-logs style="display: flex;height: 100%;"></app-logs>
</div> -->
    </div>
  </div>

  <ng-template #deviceAlertTemplate let-modal>
    <div class="modal-content custom-alert-modal">

      <!-- Header -->
      <div class="modal-header custom-header">
        <h5 class="modal-title">
          <i class="fa fa-warning text-danger"></i>
          <span>{{ "Device was disconnected" | translate }}</span>
        </h5>

        @if (device?.enhancedStatePassive == 'Available') {
        <button class="btn btn-close" (click)="modalRef.close()"></button>
        }
      </div>

      <!-- Body -->
      <div class="modal-body custom-body text-center">

        <p class="device-reason">
          {{ device?.likelyLeaveReason | deviceStatus:'likelyLeaveReason' }}
        </p>

        <div class="device-card">
          <img src="assets/x120/_default.jpg" class="device-img" />

          <div class="device-name">
            {{ device?.enhancedName | translate }}
          </div>

          <div class="device-status">
            {{ device?.enhancedStatePassive | translate }}
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="modal-footer custom-footer">
        <button style="margin-right: 2px;" class="btn btn-outline-primary btn-sm" (click)="ok()">
          <i class="fa fa-refresh"></i>
          {{ "Try to reconnect" | translate }}
        </button>

        <button class="btn btn-success btn-sm" (click)="second()">
          <i class="fa fa-sitemap"></i>
          {{ "Go to Device List" | translate }}
        </button>
      </div>

    </div>
  </ng-template>

  <!-- <div *ngIf="this.Androidloader" class="LoaderBackground col-md-12">
    <div class="col-md-4">
      <div class="progress">
        <div class="progress-bar" role="progressbar" [attr.aria-valuenow]="checkpointIndex * 20" aria-valuemin="0"
          aria-valuemax="100" [style.width.%]="checkpointIndex * 20">
        </div>
      </div>
      <img src="assets/images/Android.png" alt="Android Image" style="height: 92vh;
           width: 20%;
           position: absolute;
           left: 6.75%;
           top: 1%;">
    </div>
    <div class="col-md-8" style="position: absolute;right: 0;">
      <div class="checkpoints">
        <div class="checkpoints-container">
          <span id="head" class="fw-bold">Making {{device.model}} ready for you...</span>

          <span *ngIf="this.checkpointIndex>=1" class="fw-bold" style="display: block;"><img
            src="assets/images/{{'check.png'}}" style="height: 15px; padding-right: 5px;">Initializing your
          phone</span>
          <span *ngIf="this.checkpointIndex>=2" class="fw-bold" style="display: block;"><img
            src="assets/images/{{'check.png'}}" style="height: 15px; padding-right: 5px;">Setting the
          environment</span>
          <span *ngIf="this.checkpointIndex>=3" class="fw-bold" style="display: block;"><img
            src="assets/images/{{'check.png'}}" style="height: 15px; padding-right: 5px;">Building the device
          screen</span>
          <span *ngIf="this.checkpointIndex>=4" class="fw-bold" style="display: block;"><img
          src="assets/images/{{'check.png'}}" style="height: 15px; padding-right: 5px;">Securing the device</span>
          <span *ngIf="this.checkpointIndex>=5" class="fw-bold" style="display: block;"><img
            src="assets/images/{{'check.png'}}" style="height: 15px; padding-right: 5px;">{{device.model}} is almost
          ready...</span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="this.Iosloader" class="LoaderBackground col-md-12">
    <div class="col-md-4">
      <div class="progress Ios">
        <div class="progress-bar" style="transition: width 1s ease;" role="progressbar"
          [attr.aria-valuenow]="checkpointIndex * 20" aria-valuemin="0" aria-valuemax="100"
          [style.width.%]="checkpointIndex * 20">
        </div>
      </div>
      <img src="assets/images/Iphone.png" alt="Android Image" style="height: 92vh;
            width: 20%;
            position: absolute;
            left: 6.75%;
            top: 1%;">
    </div>
    <div class="col-md-8" style="position: absolute;right: 0;">
      <div class="checkpoints">
        <div class="checkpoints-container">
          <span id="head" class="fw-bold">Making {{device.model}} ready for you...</span>

          <span *ngIf="this.checkpointIndex>=1" class="fw-bold" style="display: block;"><img
            src="assets/images/{{'check.png'}}" style="height: 15px; padding-right: 5px;">Initializing your
          phone</span>
          <span *ngIf="this.checkpointIndex>=2" class="fw-bold" style="display: block;"><img
            src="assets/images/{{'check.png'}}" style="height: 15px; padding-right: 5px;">Setting the
          environment</span>
          <span *ngIf="this.checkpointIndex>=3" class="fw-bold" style="display: block;"><img
            src="assets/images/{{'check.png'}}" style="height: 15px; padding-right: 5px;">Building the device
          screen</span>
          <span *ngIf="this.checkpointIndex>=4" class="fw-bold" style="display: block;"><img
          src="assets/images/{{'check.png'}}" style="height: 15px; padding-right: 5px;">Securing the device</span>
          <span *ngIf="this.checkpointIndex>=5" class="fw-bold" style="display: block;"><img
            src="assets/images/{{'check.png'}}" style="height: 15px; padding-right: 5px;">{{device.model}} is almost
          ready...</span>
        </div>
      </div>
    </div>
  </div> -->